"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxAccount',
  data: function data() {
    return {
      keyword: '',
      loading: false,
      accountList: [],
      total: 0,
      page: {
        page: 1,
        limit: 20
      },
      adjustDialogVisible: false,
      detailDialogVisible: false,
      currentAccount: null,
      adjustForm: {
        type: 'add',
        fundType: 'happyFruitPending',
        zone: '',
        amount: 0,
        remark: '',
        currentUid: null
      }
    };
  },
  mounted: function mounted() {
    // 页面加载时自动查询列表
    this.handleSearch();
  },
  methods: {
    handleSearch: function handleSearch() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread({}, this.page);
      if (this.keyword && this.keyword.trim()) {
        params.keyword = this.keyword.trim();
      }
      (0, _kx.kxAccountListApi)(params).then(function (res) {
        _this.accountList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.accountList = [];
        _this.total = 0;
        _this.loading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.keyword = '';
      this.page.page = 1;
      this.handleSearch();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.page.limit = val;
      this.page.page = 1;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.page = val;
      this.handleSearch();
    },
    viewDetail: function viewDetail(row) {
      // 查看单个账户详情，使用弹窗显示
      this.currentAccount = row;
      this.detailDialogVisible = true;
    },
    openAdjustDialog: function openAdjustDialog(row) {
      this.adjustForm.currentUid = row.uid;
      this.adjustForm.type = 'add';
      this.adjustForm.fundType = 'happyFruitPending';
      this.adjustForm.zone = '';
      this.adjustForm.amount = 0;
      this.adjustForm.remark = '';
      this.adjustDialogVisible = true;
    },
    handleAdjust: function handleAdjust() {
      var _this2 = this;
      if (!this.adjustForm.amount || this.adjustForm.amount <= 0) {
        this.$message.warning('请输入有效金额');
        return;
      }
      if (!this.adjustForm.remark) {
        this.$message.warning('请输入调整原因');
        return;
      }
      (0, _kx.kxAccountAdjustApi)({
        uid: this.adjustForm.currentUid,
        type: this.adjustForm.type,
        field: this.adjustForm.fundType + this.adjustForm.zone,
        amount: this.adjustForm.amount,
        remark: this.adjustForm.remark
      }).then(function () {
        _this2.$message.success('调整成功');
        _this2.adjustDialogVisible = false;
        _this2.handleSearch();
      });
    }
  }
};